import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { SearchField } from '../../../components/ui';
import useUserSx from '../hooks/useUserSx';
import UserOrganisationSearchableSelect from './UserOrganisationSearchableSelect';
import UserProfileFilterSelect from './UserProfileFilterSelect';
import UserStatusFilterSelect from './UserStatusFilterSelect';

export default function UserTableFilters({
  search,
  onSearchChange,
  profileFilter,
  onProfileChange,
  profileOptions = [],
  profileOptionsLoading = false,
  statusFilter,
  onStatusChange,
  organisationFilter,
  onOrganisationChange,
  showOrgFilter = false,
  disabled = false,
}) {
  const { tableFilters } = useUserSx();

  return (
    <Box data-testid="user-table-filters" sx={tableFilters.root}>
      <SearchField
        placeholder="Search users..."
        value={search}
        onChange={(event) => onSearchChange?.(event.target.value)}
        size="sm"
        disabled={disabled}
        icon={<SearchIcon sx={{ fontSize: 18 }} />}
        sx={tableFilters.search}
      />

      <UserProfileFilterSelect
        options={profileOptions}
        value={profileFilter}
        onChange={onProfileChange}
        loading={profileOptionsLoading}
        disabled={disabled}
        sx={tableFilters.profileFilter}
      />

      <UserStatusFilterSelect
        value={statusFilter}
        onChange={onStatusChange}
        disabled={disabled}
        sx={tableFilters.statusFilter}
      />

      {showOrgFilter ? (
        <UserOrganisationSearchableSelect
          inline
          value={organisationFilter}
          onChange={onOrganisationChange}
          disabled={disabled}
          sx={tableFilters.orgFilter}
        />
      ) : null}
    </Box>
  );
}

UserTableFilters.propTypes = {
  search: PropTypes.string,
  onSearchChange: PropTypes.func,
  profileFilter: PropTypes.object,
  onProfileChange: PropTypes.func,
  profileOptions: PropTypes.array,
  profileOptionsLoading: PropTypes.bool,
  statusFilter: PropTypes.object,
  onStatusChange: PropTypes.func,
  organisationFilter: PropTypes.object,
  onOrganisationChange: PropTypes.func,
  showOrgFilter: PropTypes.bool,
  disabled: PropTypes.bool,
};
